export type LabelType = {
  val_id: string
  val: string
  children: LabelType[]
}
export class LabelNode implements LabelType {
  val_id: string
  val: string
  children: LabelType[]

  constructor(data: LabelType) {
    this.val_id = data.val_id
    this.val = data.val
    this.children = data.children
  }

  public addChild(data: LabelType) {
    this.children.push({
      ...data
    })
  }

  public getData() {
    return this
  }
}

export const initialNode = {
  key_id: 'root',
  key_name: 'root',
  children: []
}

type PropType = { val_id: string; val: string; parent_val_id: string }
export const buildTree = (data: { vals: PropType[] }): LabelType[] => {
  const { vals } = data
  const map = new Map<string, LabelType>()

  if (!vals) {
    return []
  }

  vals.forEach((item) => {
    map.set(item.val_id, { ...item, children: [] })
  })

  const roots: LabelType[] = []

  vals.forEach((item) => {
    if (item.parent_val_id) {
      const parent = map.get(item.parent_val_id)
      if (parent) {
        parent.children.push(map.get(item.val_id)!)
      }
    } else {
      roots.push(map.get(item.val_id)!)
    }
  })

  return roots
}

export const filterTree = (tree: LabelType[], selectedNodes: Map<string, boolean>): LabelType[] => {
  return tree
    .map((node) => {
      if (selectedNodes.has(node.val_id)) {
        return {
          ...node,
          children: filterTree(node.children, selectedNodes)
        }
      }
    })
    .filter(Boolean) as LabelType[]
}

export const getAllKeyIds = (labels: LabelType[]): string[] => {
  const result: string[] = []

  const traverse = (items: LabelType[]) => {
    for (const item of items) {
      result.push(item.val_id)
      if (item.children.length > 0) {
        traverse(item.children)
      }
    }
  }

  traverse(labels)
  return result
}
